import { getSessionToken } from "@shopify/app-bridge/utilities";

import { getAppBridgeInstance } from "./getAppBridgeInstance";

export async function getAppBridgeSessionToken(): Promise<string> {
  return getSessionToken(await getAppBridgeInstance());
}
